/**
 * @param {Object} settings
 * @returns {boolean}
 */
export default function isRemovedBranding({settings}) {
  return settings.isBlocked || settings.brandingRemoval;
}
